import { MainComponentStatus } from 'src/enums'

interface StatusOption {
  value: MainComponentStatus
  label: string
}

const STATUS_MAPPINGS: Array<{ value: MainComponentStatus; key: string }> = [
  { value: MainComponentStatus.Active, key: 'Active' },
  { value: MainComponentStatus.Incoming, key: 'Incoming' },
  { value: MainComponentStatus.InService, key: 'InService' },
  { value: MainComponentStatus.InStock, key: 'InStock' },
  { value: MainComponentStatus.Outgoing, key: 'SentToLocality' },
  { value: MainComponentStatus.NewlyRegistered, key: 'NewlyRegistered' },
  { value: MainComponentStatus.InLocalityStock, key: 'InLocalityStock' },
  { value: MainComponentStatus.ReadyToDelivery, key: 'ReadyToDelivery' },
  { value: MainComponentStatus.InStorage, key: 'inStorage' }
]

export const getStatusOptions = (translate): StatusOption[] => {
  return STATUS_MAPPINGS.map(({ value, key }) => ({
    value,
    label: translate(key, { ns: 'main-component' })
  }))
}

export const getStatusName = (translate, statusValue: number): string => {
  const status = STATUS_MAPPINGS.find(({ value }) => value === statusValue)

  if (status) {
    return translate(status.key, { ns: 'main-component' })
  }

  return `Status ${statusValue}`
}